import Icon from "@/components/Ui/Icon";
import { Vendor } from "@/contexts/vendor-context";
import { getImgProxyUrl } from "@/utils/image-proxy";
import { twMerge } from "tailwind-merge";

type Props = {
  onClick: () => void;
  vendor: Vendor | undefined;
  isSelected: boolean;
};

const VendorListItem = ({ onClick, vendor, isSelected = false }: Props) => {
  const { name, vendorId, logo } = vendor || {};

  if (!vendor) return null;

  return (
    <button
      onClick={onClick}
      className={twMerge(
        "row hover:bg-interact-card active:border-border w-full space-x-3 rounded px-4 py-3 transition-colors duration-300 active:translate-y-px",
        isSelected && "bg-interact-card",
        !isSelected && "bg-card",
      )}
    >
      <div className="row relative aspect-square w-6 overflow-hidden rounded-sm bg-white">
        {logo && (
          <img
            className="w-full p-0.5"
            src={getImgProxyUrl(logo, ["rs:fill:24:0"])}
            alt={`${name}'s logotype`}
          />
        )}
        {!logo && <Icon name="sesamy-simple" className="text-xl text-black" />}
      </div>
      <div className="column-left flex-1 space-y-1">
        <div
          className={twMerge(
            "text-sm leading-none tracking-wide first-letter:uppercase",
            isSelected && "text-white",
            !isSelected && "text-muted-foreground",
          )}
        >
          {name || vendorId}
        </div>
      </div>

      {isSelected && <Icon name="checkmark" className="text-green-600" />}
    </button>
  );
};

export default VendorListItem;
